// extracted by mini-css-extract-plugin
export default {"submitDiv":"AddRemoveTable_submitDiv__iFGET","directorMessage":"AddRemoveTable_directorMessage__EW7wP"};